import React, { useState } from "react"
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles"
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Typography,
  Badge,
  MenuItem,
  Menu,
} from "@material-ui/core"
import GitHubIcon from "@material-ui/icons/GitHub"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import MoreIcon from "@material-ui/icons/MoreVert"
import ImportContactsRoundedIcon from "@material-ui/icons/ImportContactsRounded"
import FaceRoundedIcon from "@material-ui/icons/FaceRounded"
import { AppBarStyles } from "assets/styles/Header"
import { graphql, Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { LINKEDIN, GITHUB } from "services/constants"

const themeColor = createMuiTheme({
  palette: {
    primary: {
      main: "#f1c40f",
    },
    secondary: {
      main: "#f44336",
    },
  },
})

interface Props {
  title: string
}

const Header: React.FC<Props> = ({ title }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "am-logo.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  // const location = useLocation()
  const classes = AppBarStyles()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = React.useState<null | HTMLElement>(null)

  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
  }

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  // const renderEmoji = () => {
  //   let emoji
  //   const { pathname } = location
  //   if (pathname === "/") {
  //     emoji = <span role="img">🏠</span>
  //   } else if (pathname === "/blog" || pathname.length > 10) {
  //     emoji = <span role="img">📖</span>
  //   } else if (pathname === "/about-me") {
  //     emoji = <span role="img">😁</span>
  //   }

  //   return emoji
  // }

  const menuId = "primary-search-account-menu"
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <Avatar alt="MyImg" src={MyImg} className={classes.large} /> */}
      {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
    </Menu>
  )

  const mobileMenuId = "primary-search-account-menu-mobile"
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleMobileMenuClose}>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <ImportContactsRoundedIcon />{" "}
          </Badge>
        </IconButton>
        <Link className={classes.link} to="/blog">
          Blog
        </Link>
      </MenuItem>
      <MenuItem onClick={handleMobileMenuClose}>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <FaceRoundedIcon />
          </Badge>
        </IconButton>
        <Link className={classes.link} to="/about-me">
          About Me
        </Link>
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleMobileMenuClose()
          window.location.href = GITHUB
        }}
      >
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <GitHubIcon />
          </Badge>
        </IconButton>
        <Typography paragraph style={{ margin: 0, fontFamily: "Quicksand" }}>
          Github Account
        </Typography>
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleMobileMenuClose()
          window.location.href = LINKEDIN
        }}
      >
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <LinkedInIcon />
          </Badge>
        </IconButton>
        <Typography paragraph style={{ margin: 0, fontFamily: "Quicksand" }}>
          LinkedIn Account
        </Typography>
      </MenuItem>
    </Menu>
  )

  return (
    <MuiThemeProvider theme={themeColor}>
      <div className={classes.grow}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <Link to="/">
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="open drawer"
              >
                {/* {renderEmoji()} */}
                <Img
                  className={classes.avatar}
                  fluid={data.file.childImageSharp.fluid}
                  alt="Arif Logo"
                />
              </IconButton>
            </Link>
            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <Link to="/about-me">
                <Button color="inherit" className={classes.link}>
                  About Me
                </Button>
              </Link>
              <Link to="/blog">
                <Button color="inherit" className={classes.link}>
                  Blog
                </Button>
              </Link>
              <IconButton
                aria-label="show 4 new mails"
                color="inherit"
                onClick={() => {
                  window.location.href = GITHUB
                }}
              >
                <Badge badgeContent={0} color="secondary">
                  <GitHubIcon />
                </Badge>
              </IconButton>
              <IconButton
                aria-label="show 17 new notifications"
                color="inherit"
                onClick={() => (window.location.href = LINKEDIN)}
              >
                <Badge badgeContent={0} color="secondary">
                  <LinkedInIcon />
                </Badge>
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
      </div>
    </MuiThemeProvider>
  )
}

export default Header
